/** @format */
import Diagram_kyeongbok from '@/assets/diagram/kyeongbok.png';
import Diagram_templestay from '@/assets/diagram/templestay.png';
import Diagram_bluehouse from '@/assets/diagram/bluehouse.png';
import Diagram_warmemorial from '@/assets/diagram/warmemorial.png';
import Diagram_museumtown from '@/assets/diagram/museumtown.png';
import Diagram_arttown from '@/assets/diagram/arttown.png';
import Diagram_seoul284 from '@/assets/diagram/seoul284.png';
import Diagram_koreanstylehouse from '@/assets/diagram/koreanstylehouse.png';
import Diagram_seoul_lib from '@/assets/diagram/seoul_lib.png';
import Diagram_changduk from '@/assets/diagram/changduk.png';

import Title_kyeongbok from '@/assets/title/jp/kyeongbok.png';
import Title_templestay from '@/assets/title/jp/templestay.png';
import Title_bluehouse from '@/assets/title/jp/bluehouse.png';
import Title_warmemorial from '@/assets/title/jp/warmemorial.png';
import Title_museumtown from '@/assets/title/jp/museumtown.png';
import Title_arttown from '@/assets/title/jp/arttown.png';
import Title_seoul284 from '@/assets/title/jp/seoul284.png';
import Title_koreanstylehouse from '@/assets/title/jp/koreanstylehouse.png';
import Title_seoul_lib from '@/assets/title/jp/seoul_lib.png';
import Title_changduk from '@/assets/title/jp/changduk.png';

export default {
    kyeongbok: {
        diagram: Diagram_kyeongbok,
        title: Title_kyeongbok,
        msg: `<p>景福宮(キョンボックン)は朝鮮王朝第一の王宮で、北にそびえる北岳山(プガクサン)の麓に位置し、正門である光化門(クァンファムン)の前には広い六曺通り(現在の世宗路)が伸びていて、王都である漢陽(ソウル)の都市計画の中心でもある。1395年に太祖・李成桂(イ・ソンゲ)が創建し、1592年に興宣大院君(フンソンデウォングン)が主導して増築された景福宮は、約500棟の建物が迷路のように建ち並ぶ荘厳な姿を誇ったが、壬辰倭乱によって消失し、高宗(コジョン)の時代であった1867年に再建された。</p>

<p>王宮の中には王と官吏の政務施設、王族の生活空間、休息のための後苑が設けられており、また王妃の中宮、王世子の東宮、高宗が建てた乾清宮(コンチョングン)など、王宮の中にまたいくつかの小さな宮が複雑に集まっている場所でもあった。しかし、日本植民地時代にほとんどの建物が撤去され、勤政殿(クンジョンジョン)などごく一部の中心的な建物のみが残り、朝鮮総督府庁舎が建てられて王宮自体が裏に隠れてしまった。幸いにも1990年から本格的な復元事業が進められ、旧総督府庁舎は撤去されて興礼門(フンネムン)一帯が復元され、王と王妃の寝殿、東宮、乾清宮、泰元殿(テウォンジョン)一帯のかつての姿を取り戻しつつある。</p>`,
        scene: 'scene_kyeongbok',
        vr_url:
            'https://look360.kr/vr/2020sitm_royalpalace/2020sitm_royalpalace_jp',
        site_url:
            'http://www.royalpalace.go.kr:8080/html/eng_gbg/main/main.jsp',
        narration: 'kyeongbok_jp',
    },
    templestay: {
        diagram: Diagram_templestay,
        title: Title_templestay,
        msg: `<p>韓国仏教の最大宗派である曹渓宗を代表する寺院。1910年に韓龍雲(ハン・ヨンウン)らが中心となって建てた「覚皇寺」が1938年に大々的な改修を経て「太古寺」となり、1954年に日本植民地時代の残滓を取り除く仏教浄化運動により現在の名前となった。「曹渓」という名称は中国禅仏教の六大祖師とされ、修行の手本として崇められている慧能大師が過ごした「曹渓山」から付けられた。</p>

<p>中心となる建物の大雄殿は太古寺の修復の際に全羅北道・井邑(チョンウプ)にあった寺院の建物をそのまま移築したもので、大きな柱がいにしえの華やかさを放っている。前庭にある七層石塔には釈迦の真身舍利が奉安されており、樹齢500年の白松と400年のエンジュが大雄殿の建物を見守るように取り囲んでいる。建物の周りには精進料理店やお茶屋さん、仏教用品を扱うお店が集まり、仏教の街を形成している。併設されている仏教中央博物館は、韓国全国の寺院から保管するのが難しい仏教文化財が集められて管理・展示されている場所で、貴重な韓国の仏教美術の宝庫となっている。</p>

<p>曹渓寺では僧侶と訪問者の間に何らの壁もなく、忙しさの中で心を落ち着かせて静けさを保ち、忙しく生きる中でも心の温かさを失うことのないよう、参加する気持ちさえあればすぐに参加できるテンプルステイも開かれている。</p>`,
        scene: 'scene_templestay',
        vr_url: 'https://look360.kr/vr/2020sitm_jogyesa/2020sitm_jogyesa_jp',
        site_url: 'http://www.jogyesa.kr/user/japan/',
        narration: 'templestay_jp',
    },
    bluehouse: {
        diagram: Diagram_bluehouse,
        title: Title_bluehouse,
        msg: `<p>青瓦台は「青い瓦ぶきの建物」であることから名付けられた。韓国の大統領が執務と生活をする空間である。高麗時代の王宮跡だった旧青瓦台から、現在の青瓦台の姿になるまでの変化の過程を一目で観ることができる。</p>

<p>青瓦台の前庭にある青瓦台サランチェは、韓国の観光地に加え、青瓦台と歴代大統領の歩みを知ることができる総合観光広報館となっており、1階は韓国観光展示館・ギフトショップ・休憩スペース、2階は青瓦台館・国民疎通体験館で構成されている。</p>

<p>韓国観光展示館は二つのテーマからなっている。青瓦台の中でのエピソードをはじめ歴代大統領の歩みをたどる展示館と、美しい韓国の文化と旅行地を紹介する展示館である。アメリカ大統領夫人のメラニア・トランプ氏と韓国大統領夫人の金正淑(キム・ジョンスク)氏が一緒に歩いた青瓦台「不老門」が、二つの空間を繋いでいる。</p>

<p>青瓦台館は文在寅(ムン・ジェイン)大統領と現在の青瓦台について紹介している。現政権の過去、現在、未来のビジョンを共有する歴史記念館であり文化広報館として、実際の大統領の執務室がそのまま再現されているスペースとなっている。</p>`,
        scene: 'scene_bluehouse',
        vr_url:
            'https://look360.kr/vr/2020sitm_cwdsarangchae/2020sitm_cwdsarangchae_jp',
        site_url: 'https://cwdsarangchae.kr/jpn/',
        narration: 'bluehouse_jp',
    },
    warmemorial: {
        diagram: Diagram_warmemorial,
        title: Title_warmemorial,
        msg: `<p>戦争の犠牲を追悼し、平和を祈念する展示館。約82.6㎢の敷地に1994年に完成した記念館は、1万点を超える戦争関連の記念物が展示されている大規模なスペースだ。正門の左右に広開土大王碑の実物のレプリカと国軍将校と人民軍の兵士が抱き合う姿の「兄弟の像」が立っていて、先史時代の青銅の剣といのちの木をモチーフにしたシンボル塔が中央にそびえる。「兄弟の像」は朝鮮戦争当時、互いに銃口を向け合う敵として出会った実際の兄弟の話をモチーフにしたオブジェだ。</p>

<p>平和の広場を過ぎて続く建物は、6つの展示エリアに分かれている屋内展示場である。水と光がひとつになった護国追悼室は、軍創設以降に戦死した17万人の名前が載った帳簿が保管されている厳粛な空間である。先史時代から大韓帝国までこの地で使われた数々の武器が展示されている戦争歴史室から始まり、朝鮮戦争室、海外派兵室、国軍発展室などで、朝鮮戦争から始まって世界に派遣されて活躍する国軍と発展する軍事設備を観ることができる。</p>`,
        scene: 'scene_warmemorial',
        vr_url: 'https://look360.kr/vr/2020sitm_warmemo/2020sitm_warmemo_jp',
        site_url: 'https://www.warmemo.or.kr/LNG/main.do?lan=jp',
        narration: 'warmemorial_jp',
    },
    museumtown: {
        diagram: Diagram_museumtown,
        title: Title_museumtown,
        msg: `<p>敦義門(トニムン)博物館マウル(村)は、全面撤去の後に公園にするのが元々の計画だったが、その歴史的価値を認められソウル型都市再生事業により2017年に町全体が博物館となった歴史と文化の空間である。最初は芸術家のための展示スペースとして活用されてきたが、2019年4月から展示・イベント・体験などが開かれる市民参加型スペースに生まれ変わった。ここは、マウル展示館(16棟)、体験教育館(9棟)、マウル創作所(9棟)の3つのエリアからなっている。</p>

<p>中心的なスペースである「マウル展示館」には、3・1運動と大韓民国臨時政府樹立100周年記念テーマ展示館「独立運動家の家」、1960～80年代の一般家庭を復元した「生活史展示館」、市民の所蔵品を展示する「市民ギャラリー」などがある。また、伝統文化の職人による「体験教育館」は、韓紙工芸、書芸、刺繍工芸、タクチョンイ工房、お茶屋やカフェなど、伝統韓屋に合わせた体験イベントを提供するスペースである。また、公募によって集められた運営者による「マウル創作所」は、時代別の路地での遊び方や遊び道具を展示・体験できるスペースだ。このほか、町の広場や路地など屋外のスペースを活用した様々なイベントが開かれており、訪れた人々に多彩な見どころを提供している。</p>`,
        scene: 'scene_museumtown',
        vr_url:
            'https://look360.kr/vr/2020sitm_dmvillage/2020sitm_dmvillage_jp',
        site_url: 'http://dmvillage.info',
        narration: 'museumtown_jp',
    },
    arttown: {
        diagram: Diagram_arttown,
        title: Title_arttown,
        msg: `<p>文来洞(ムルレドン)は日本植民地時代にできた紡績工場をはじめ、工場との縁が深い場所である。当時紡績機械を「ムルレ」と呼んだことが、ここの地名である「文来洞」の由来であるそうだ。その後、鉄鋼工場や鉄材商がここに密集するようになり、現在は芸術家が集まるようになって芸術と鉄工所が共存するエリアに生まれ変わっている。</p>

<p>ただの路地というしかないようなスペースに何にも縛られない自由な壁画が描かれており、路地の角を曲がるたびにびっくりするような風景があちこちにある。屋根のない美術館とも言えるだろう。</p>

<p>ソウルの古い工業団地は農業より工業が尊ばれるようになった近代化の痕跡で、今よりも工場が集まっていた1970年代の文来洞は、労働者と機械、そして鉄の世界だった。今でも、当時をしのばせる風景が路地のあちこちに残る。その上に誰かが筆で線を引いて色を塗り、ソウルのありきたりな街並みではない、芸術家の手によってユニークな街に変わりつつあるエリアである。</p>`,
        scene: 'scene_arttown',
        vr_url:
            'https://look360.kr/vr/2020sitm_mullaertrefactory/2020sitm_mullaertrefactory_jp',
        site_url: '',
        narration: 'arttown_jp',
    },
    seoul284: {
        diagram: Diagram_seoul284,
        title: Title_seoul284,
        msg: `<p>KTX新駅舎の開業後に鉄道駅としての機能を失った旧ソウル駅舎が、原形のままに復元されて複合文化スペースとなり、2012年4月に公式オープンした。ソウル特別市中区統一路1番地にある。</p>

<p>スイスのルツェルン駅をモデルにしたというこの重厚なレンガの建物は、一時期は植民地の関門だった。日本はここから満州だけでなくモスクワやベルリンまで結ぶ計画を立てていた。敗戦によりその野望は泡となったが、ソウル駅はその後も朝鮮半島の交通の中心であった。約10年前に新しい駅舎が建てられると、旧ソウル駅舎は「文化駅ソウル284」という名の複合文化スペースとして生まれ変わった。</p>

<p>名称は国民からの公募によって付けられたもので、「284」は旧ソウル駅舎が史跡第284号の国家指定文化財であることを意味する。史跡の姿と価値を保存すると同時に、様々な文化が交差する駅の象徴性を活かしたスペースで、現在では講演・公演・展示・研究など様々なプログラムが開かれている。</p>`,
        scene: 'scene_seoul284',
        vr_url: 'https://look360.kr/vr/2020sitm_seoul284/2020sitm_seoul284_jp',
        site_url: 'https://www.seoul284.org/english/',
        narration: 'seoul284_jp',
    },
    koreanstylehouse: {
        diagram: Diagram_koreanstylehouse,
        title: Title_koreanstylehouse,
        msg: `<p>北村(プクチョン)は、朝鮮時代に造成された両班階級の居住地として1920年代までそれほど大きな変化がなかったが、1930年代にソウルの行政区域が拡張され、都市の構造も近代的に変わったことで変化が起きた。住宅経営会社が北村の大型の土地と林野を買い入れ、その場所に中小規模の韓屋を大規模に建設したのだ。現在韓屋が密集する嘉会洞(カフェドン)、三清洞(サムチョンドン)、桂洞(ケドン)の韓屋居住地は、すべてこの時期に形成された。</p>

<p>この有名な北村韓屋村にある韓屋文化院は韓屋教育専門機関で、2000年3月に韓屋の価値と美しさを広く発信し、継承・発展させるために設立された。韓屋文化院は、韓屋の建築方式・技法、技術史研究を通じて専門人材を育成するだけでなく、様々な講座を開くなど、50人あまりの文化財・伝統文化の専門家らが後学の指導に当たっている。直接建築事業団を運営し、2000年のイギリス大英博物館(British Museum)における韓屋サランバンの技術指導をはじめ、北村韓屋村のゲストハウスなど韓屋の新築・改築、韓屋型のリフォームなどに積極的に参加している。</p>`,
        scene: 'scene_koreanstylehouse',
        vr_url:
            'https://look360.kr/vr/2020sitm_hanok_seoul/2020sitm_hanok_seoul_jp',
        site_url: 'http://www.hanok.org',
        narration: 'koreanstylehouse_jp',
    },
    changduk: {
        diagram: Diagram_changduk,
        title: Title_changduk,
        msg: `<p>王宮の庭園という意味から「禁苑」、また王宮の北にあることから「北苑」、さらに裏側にある庭園という意味から「後苑」と呼ばれてきた。後苑は厳密に言うと昌徳宮(チャンドックン)の後苑であるが、この後苑が位置するところがちょうど昌徳宮と昌慶宮(チャンギョングン)の裏手となるため、自然と二つの王宮が共有する形になっている。</p>

<p>後苑は合わせて5つの大きな地域から構成されている。一番目は芙蓉池を中心に、その周りの芙容亭、宙合楼、暎花堂、書香閣などの建物が並ぶ地域で、山稜を越えて二番目の地域と接している。二番目は愛蓮池と愛蓮亭、そして演慶堂のある地域で、ここからまた山稜を越えると三番目の地域に続いている。三番目は観纜亭と尊徳亭、砭愚榭のある地域である。
<br/>この地域から山稜を越えると、次の玉流川地域へと続く。<p>

<p>四番目は、玉流川を中心に逍遙亭、清漪亭、太極亭などが並ぶ地域である。五番目は、北西の新璿源殿が建てられた地域である。</p>`,
        scene: 'scene_changduk_buyongji',
        vr_url: 'https://look360.kr/vr/2020sitm_cdg/2020sitm_cdg_jp',
        site_url: 'http://www.cdg.go.kr/eng/',
        narration: 'changduk_jp',
    },
    seoul_lib: {
        diagram: Diagram_seoul_lib,
        title: Title_seoul_lib,
        msg: `<p>ソウル特別市の記録と情報を市民と共有する知識のスペース。疎通のシンボルであるソウル広場を持つソウル記録文化館は、ソウル市民とソウル特別市のコミュニケーションの空間であり、ソウルの過去と現在、そして未来をつなぐ歴史の空間でもある。</p>

<p>展示館では2014年に行われた「ソウル広場記録収集及びコンテンツ開発事業」と2015年にソウル図書館で市民に公開された「ソウル広場記録展示事業」を総合的にまとめて現行化した記録展示が行われており、ストーリーテリングのために設定された仮想のソウル市民のクボ氏が成長しながら経験する個人の歴史と韓国の現代史がソウル広場を中心に展開される。</p>

<p>旧市長室は、独立後から2008年5月まで60年余りにわたり歴代のソウル市長が使用した執務空間である。市長室は旧市庁舎の3階中央にあり、執務室や接見室などで構成されていた。復元されたスペースには、当時の道具や家具などがそのまま再現されている。</p>`,
        scene: 'scene_seoul_lib',
        vr_url:
            'https://look360.kr/vr/2020sitm_lib_seoul/2020sitm_lib_seoul_jp',
        site_url: 'https://lib.seoul.go.kr/rwww/html/jp/main.jsp',
        narration: 'seoul_lib_jp',
    },
};
/*
https://look360.kr/project/ioconvex_intro/#/jp/kyeongbok
https://look360.kr/project/ioconvex_intro/#/jp/templestay
https://look360.kr/project/ioconvex_intro/#/jp/bluehouse
https://look360.kr/project/ioconvex_intro/#/jp/warmemorial
https://look360.kr/project/ioconvex_intro/#/jp/museumtown
https://look360.kr/project/ioconvex_intro/#/jp/arttown
https://look360.kr/project/ioconvex_intro/#/jp/seoul284
https://look360.kr/project/ioconvex_intro/#/jp/koreanstylehouse
https://look360.kr/project/ioconvex_intro/#/jp/changduk
https://look360.kr/project/ioconvex_intro/#/jp/seoul_lib

http://localhost:8080/#/jp/kyeongbok
http://localhost:8080/#/jp/templestay
http://localhost:8080/#/jp/bluehouse
http://localhost:8080/#/jp/warmemorial
http://localhost:8080/#/jp/museumtown
http://localhost:8080/#/jp/arttown
http://localhost:8080/#/jp/seoul284
http://localhost:8080/#/jp/koreanstylehouse
http://localhost:8080/#/jp/changduk
http://localhost:8080/#/jp/seoul_lib
*/
